import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const AaliMusic = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('visible'); });
    }, { threshold: 0.2 });
    document.querySelectorAll('.scroll-reveal, .service-item, .info-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="company-hero" style={{ background: 'linear-gradient(135deg, #4c1d95, #7e22ce)' }}>
        <div className="hero-content">
          <h1>AALI MUSIC</h1>
          <p>Music label and production company promoting diverse artists and creating chart-topping hits</p>
        </div>
      </div>
      <div className="company-content">
        <div className="container">
          <div className="company-grid">
            <div className="left scroll-reveal">
              <h2>About AALI MUSIC</h2>
              <p>AALI MUSIC is a vibrant music label that discovers and nurtures talent while producing music that defines cultural moments. Our roster includes established artists and emerging talents across multiple genres.</p>
              <h3>Our Services</h3>
              <div className="services-list">
                <div className="service-item"><span>✔</span> Music Production</div>
                <div className="service-item"><span>✔</span> Artist Management</div>
                <div className="service-item"><span>✔</span> Music Distribution</div>
                <div className="service-item"><span>✔</span> Recording Studio Services</div>
                <div className="service-item"><span>✔</span> Live Events & Concerts</div>
              </div>
            </div>
            <div className="info-card scroll-reveal">
              <h4>Company Info</h4>
              <div className="info-block">
                <span className="info-label">Industry</span>
                <strong className="info-value">Media & Entertainment</strong>
              </div>
              <div className="info-block">
                <span className="info-label">Parent Company</span>
                <strong className="info-value">AALI GROUP</strong>
              </div>
              <div className="actions">
                <Link to="/contact" className="btn-primary">Get in Touch</Link>
                <Link to="/coming-soon" className="btn-primary">Visit Main Website</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AaliMusic;